import type { ResidentSubscription } from 'src/service/engageFrontendGateway';

/**
 * Sample subscriptions used when the page is loaded under the `engage_mock`
 * organization slug. Mirrors the real gateway DTO so the page renders the
 * exact same UI without a backend round-trip.
 *
 * The publication type keys match the canonical engage publication enum in
 * messaging-service/src/publication/types/PublicationType.ts.
 */
export const MOCK_RESIDENT_SUBSCRIPTIONS: ResidentSubscription[] = [
  {
    id: 'mock-page-all',
    publicationTypeKey: 'engage-page-all-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    title: 'AllPages - Mock City',
  },
  {
    id: 'mock-page-project-downtown',
    publicationTypeKey: 'engage-page-project-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    entityId: 'mock-entity-downtown',
    title: 'Downtown Plan - Mock City',
  },
  {
    id: 'mock-page-project-parks',
    publicationTypeKey: 'engage-page-project-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: false,
    entityId: 'mock-entity-parks',
    title: 'Parks Renewal - Mock City',
  },
  {
    id: 'mock-page-update',
    publicationTypeKey: 'engage-page-update-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    entityId: 'mock-entity-update',
    title: 'Spring 2026 Construction Update',
  },
  {
    id: 'mock-page-hub',
    publicationTypeKey: 'engage-page-hub-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    entityId: 'mock-entity-hub',
    title: 'Sustainability Hub',
  },
  {
    id: 'mock-page-home',
    publicationTypeKey: 'engage-page-home-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    title: 'Home page announcements - Mock City',
  },
  {
    id: 'mock-activity-all',
    publicationTypeKey: 'engage-activity-all-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
  },
  {
    id: 'mock-activity-survey',
    publicationTypeKey: 'engage-activity-survey-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    entityId: 'mock-entity-survey',
    title: 'Annual Resident Satisfaction Survey',
  },
  {
    id: 'mock-activity-maps',
    publicationTypeKey: 'engage-activity-maps-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: false,
    entityId: 'mock-entity-map',
    title: 'Bike Lane Suggestion Map',
  },
  {
    id: 'mock-activity-discussion',
    publicationTypeKey: 'engage-activity-discussion-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: true,
    entityId: 'mock-entity-discussion',
    title: 'Public Library Renovation Discussion',
  },
  {
    id: 'mock-activity-ideation',
    publicationTypeKey: 'engage-activity-ideation-resident',
    residentId: 'mock-resident',
    customerId: 'mock-customer',
    channel: 'email',
    isEnabled: false,
    entityId: 'mock-entity-ideation',
    title: 'Ideas for the Riverfront Park',
  },
];
